package com.exura.features.plandefinition.domain.model.element

import com.exura.features.plandefinition.domain.model.series.HourOfDay
import com.exura.features.plandefinition.domain.model.series.PartOfDay
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Represents a timed instruction element that needs to be completed at a specific time.
 * Generated from InstructionSeries.
 * Updated to implement SerializableDomainModel through BasePlanElement.
 */
data class InstructionElement(
    override val firebaseDocId: String? = null,
    override val firebaseDocPrefix: CollectionReference? = null,
    override val title: String,
    val instruction: String,
    override val imageUrl: String? = null,
    override val relativeDay: Int,
    val partOfDay: PartOfDay? = null,
    val exactTime: HourOfDay? = null,
    override val durationInMinutes: Int = 5,
) : BasePlanElement(
    firebaseDocId = firebaseDocId,
    firebaseDocPrefix = firebaseDocPrefix,
    elementType = ElementType.INSTRUCTION,
) {
    init {
        // Validate that either partOfDay or exactTime is specified, but not both
        require((partOfDay == null) != (exactTime == null)) {
            "Either partOfDay or exactTime must be specified, but not both"
        }
    }

    override fun durationInDays(): Int {
        val minutesInDay = 24 * 60
        val minutes = durationInMinutes
        return (minutes + minutesInDay - 1) / minutesInDay
    }
}
